<section class="no-auth-page">
  <header>
    <h3>{{ 'auth.login.title' | translate }}</h3>
    <h4>{{ 'auth.login.subtitle' | translate }}</h4>
  </header>
  <login-form></login-form>
</section>
